export enum TipoLembreteEnum {
  PARA_CLIENTE = 'PARA_CLIENTE',
  PARA_MIM = 'PARA_MIM',
}

export const TIPO_LEMBRETE_LABEL: Record<string, string> = {
  [TipoLembreteEnum.PARA_CLIENTE]: 'Para cliente',
  [TipoLembreteEnum.PARA_MIM]: 'Para mim',
};
